import { render, staticRenderFns } from "./ZoneKpiTable.vue?vue&type=template&id=f1a9d69c&"
import script from "./ZoneKpiTable.vue?vue&type=script&lang=js&"
export * from "./ZoneKpiTable.vue?vue&type=script&lang=js&"
import style0 from "./ZoneKpiTable.vue?vue&type=style&index=0&id=f1a9d69c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QBtn,QMenu,QList,QItem,QItemSection,QToggle,QTable,QTr,QTh,QTd,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBtn,QMenu,QList,QItem,QItemSection,QToggle,QTable,QTr,QTh,QTd})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
